export const accessTokenKey = 'accessToken';
export const refreshTokenKey = 'refreshToken';
export const signUpFieldsKey = 'signUpFields';
